module.exports = __webpack_public_path__ + "img/icon-ellipse.1c17f24c.svg";